/**
 * Leave override helpers.
 *
 * getLeaveBlock  — extract a leave_block detail from an Axios error
 * withLeaveOverride — append leave_override_reason to a URL
 */

// Returns detail if the axios error is a leave_block, else null.
export const getLeaveBlock = (error) => {
  const d = error?.response?.data?.detail;
  return d && typeof d === 'object' && d.error === 'leave_block' ? d : null;
};

// Appends leave_override_reason to a URL that may already have a query string.
export const withLeaveOverride = (url, reason) =>
  reason
    ? `${url}${url.includes('?') ? '&' : '?'}leave_override_reason=${encodeURIComponent(reason)}`
    : url;
